import * as React from 'react';
import {
  KeyboardArrowDownRounded,
  KeyboardArrowRightRounded,
} from '@mui/icons-material';
import { StyledExpandableContent, StyledTypo } from './CustomAccordion.styled';

type CustomAccordionProps = {
  toggleExpand: () => void;
  expanded: boolean;
  mainText: React.ReactNode;
  expandedContent: React.ReactNode;
  showWithIcons?: boolean;
  isVerticalScrollable?: boolean;
};
const CustomAccordion: React.FC<CustomAccordionProps> = ({
  toggleExpand,
  expanded,
  mainText,
  expandedContent,
  showWithIcons = true,
  isVerticalScrollable = false,
}) => {
  return (
    <>
      <StyledTypo variant="subtitle1" onClick={toggleExpand}>
        {showWithIcons &&
          (!expanded ? (
            <KeyboardArrowRightRounded />
          ) : (
            <KeyboardArrowDownRounded />
          ))}
        {mainText}
      </StyledTypo>
      <StyledExpandableContent
        expanded={expanded}
        isVerticalScrollable={isVerticalScrollable}
      >
        {expandedContent}
      </StyledExpandableContent>
    </>
  );
};
export default CustomAccordion;
